import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import BackButtonComponent from './backButton.component';
import { version } from '../../../package.json';

/* eslint-disable */
const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  background: {
    background: 'radial-gradient(at top, #49b2ed, #1183e6)',
    boxShadow: 'none',
  },
  logo: {
    width: '50px',
    verticalAlign: 'middle',
    padding: '10px 10px 10px 0px',
  },
  flex: {
    flex: 1,
  },
  linkStyle: {
    textDecoration: 'none',
    color: '#fff',
    textTransform: 'uppercase',
  },
  linkStyleLeft: {
    float: 'right',
    textDecoration: 'none',
    color: '#fff',
  },
  right: {
    textDecoration: 'none',
    float: 'left',
    color: '#fff',
  },
  appversion: {
    position: 'fixed',
    margin: '0',
    padding: '5px',
    fontSize: '13px',
    left: '0',
    bottom: '0',
    zIndex: '9999',
  },
  indicator: {
    backgroundColor: '#fafafa',
    marginBottom: '-15px',
    height: '60px',
    overflow: 'hidden',
    borderRadius: '15px',
  },
  tabContainer: {
    padding: '0 0 0 10px',
  },
  selectedtab: {
    zIndex: '40',
    color: '#525252',
    transition: 'all 0.4s'
  },
  scrollfix: {
    overflow: 'hidden',
  }
});

const HeaderComponent = ({ classes, fileName, currentTab, changeTab, tabs,sessionId }) => {
  return (
    <div className={classes.root}>
      <AppBar className={classes.background} position="static">
        <Toolbar>
          <BackButtonComponent url={`/project/${sessionId}`}/>
          <Typography variant="h6" align="center" className={classes.flex}>
            <NavLink className={classes.linkStyle} to={`/project/${sessionId}`}>
              {/* <img className={classes.logo} src="/favicon.ico" alt="Logo" /> */}
              <span>{fileName}</span>
            </NavLink>
          </Typography>
          <NavLink className={classes.linkStyle} to="/help">
            <IconButton>
              <Icon className={classes.linkStyleLeft}>help</Icon>
            </IconButton>
          </NavLink>
        </Toolbar>
        {renderTabs(currentTab, changeTab, tabs, classes)}
      </AppBar>
      <a href="javascript:(function(){let deg=0;document.documentElement.style.transitionDuration='3s';setInterval(()=>{deg=deg===360?0:deg+6;document.documentElement.style.filter=`hue-rotate(${deg}deg)`},3000)})()">
      <Typography className={classes.appversion} variant="caption" gutterBottom >
        v{version}
      </Typography>
    </a>
    </div>
  )
};

function renderTabs(currentTab, changeTab, tabs, classes) {
  return (
    <Tabs
      classes={{
        indicator: classes.indicator,
        scroller: classes.scrollfix,
        root: classes.roottabs,
        flexContainer: classes.tabContainer
      }}
      value={currentTab}
      onChange={changeTab}
    >
      {
        tabs.map((tab, index) => {
          return <Tab classes={{ selected: classes.selectedtab }} label={tab} key={index} />;
        })
      }
    </Tabs>
  );
}

HeaderComponent.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  fileName: PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
  currentTab: PropTypes.number.isRequired,
  changeTab: PropTypes.func.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(HeaderComponent);
